import { Component, Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  private link!: string | undefined;
  subject = new Subject();
  logotag = new Subject();

  defineLink(link: string | undefined) {
    this.link = link;
    this.subject.next(this.link);
  }

  getLink() {
    return this.link;
  }

  getTagLogo() {
    return this.logotag;
  }

  defineLogoTag(logo: string | undefined) {
    this.logotag.next(logo);
  }




  clear() {
    this.link = undefined;
    this.subject.next(this.link);
  }
}
